import React, { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import {
    buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet,
    languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings';
import axios from 'axios';

import moment from 'moment-timezone'
import 'react-tempusdominus-bootstrap';
import { condominiumBoardElectionModelGet } from '../../models/condominiumBoard/elections';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { condominiumBoardRoleModelGet } from '../../models/condominiumBoard/role';

const currentMethod = 'ElectionAdd';

const { icons, labels, messages, react, } = globalSettings;
const { html: reactHtml, } = react;

export default function ElectionAdd({
    $ = {},
    auth = {},
    condominiumBoardElection = condominiumBoardElectionModelGet({}),
    setCondominiumBoardElection = () => { },
    dtId = '',
    dtRowIndex = 0,
    showModal = false,
    setShowModal = {},
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [descriptionError, setDescriptionError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const startDateId = 'startDate';
    //const inputStartDateId = 'inputStartDate';
    const endDateId = 'endDate';
    //const inputEndDateId = 'inputEndDate';
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning',
                id: 'btnModalSave',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'btnModalBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        // dataTables: {
        //     buildings: {
        //         inputs: {
        //             search: {
        //                 id: `${dtBuildingsId}_filter input`,
        //                 className: '',
        //             },
        //         },
        //         selects: {
        //             entries: {
        //                 id: `${dtBuildingsId}_length select`,
        //                 className: '',
        //             },
        //         },
        //     },
        // },
        icons: {
            save: {
                id: 'iconModalSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'inputModalName',
                className: 'form-control',
            },
            description: {
                id: 'inputModalDescription',
                className: 'form-control',
            },
            endDate: {
                id: 'inputModalEndDate',
                className: 'form-control datetimepicker-input',
            },
            startDate: {
                id: 'inputModalStartDate',
                className: 'form-control datetimepicker-input',
            },
        },
        radios: {
            // even: {
            //     id: 'radioModalEven',
            //     className: 'icheck-primary d-inline mx-4',
            // },
            // odd: {
            //     id: 'radioModalOdd',
            //     className: 'icheck-primary d-inline',
            // },
            // both: {
            //     id: 'radioModalBoth',
            //     className: 'icheck-primary d-inline mx-4',
            // },
        },
        spinners: {
            save: {
                id: 'spModalSave',
                className: '',
            },
            back: {
                id: 'spModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            response = dateInControlSet({
                date: new Date(),
                startDate: condominiumBoardElection?.startDate,
                endDate: condominiumBoardElection?.endDate,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const errorDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setRemarkError('');
            setEndDateError('');
            setStartDateError('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                start: $(`#${controls?.inputs?.startDate?.id}`)?.val(),
                end: $(`#${controls?.inputs?.endDate?.id}`)?.val(),
                startDtp: $(`#${startDateId}`)?.datetimepicker('date')?._d,
                endDtp: $(`#${endDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: condominiumBoardElection?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: condominiumBoardElection?.remark, subMethod: currentMethod, })?.result) {
                setRemarkError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            //const dateTimeObj.start = $(`#${controls?.inputs?.startDate?.id}`)?.val();
            if (isUndNullEmp({ data: dateTimeObj?.start, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: condominiumBoardElection?.startDate, subMethod: currentMethod, })?.result) {
                setStartDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            //const dateTimeObj?.end = $(`#${controls?.inputs?.endDate?.id}`)?.val();
            if (isUndNullEmp({ data: dateTimeObj?.end, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: condominiumBoardElection?.endDate, subMethod: currentMethod, })?.result) {
                setEndDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            //#region old code
            // if (moment(new Date(condominiumBoardElection.startDate).toUTCString()).isSame(new Date(condominiumBoardElection.endDate).toUTCString())) {
            //     setStartDateError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
            //     setEndDateError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
            //     response.isWarning = true;
            // }
            //#endregion old code

            //#region old code
            // if (moment(new Date(dateTimeObj?.end).toUTCString()).isBefore(new Date(dateTimeObj?.start).toUTCString())) {
            //     setStartDateError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
            //     setEndDateError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
            //     response.isWarning = true;
            // }
            //#endregion old code

            if (moment(new Date(dateTimeObj?.endDtp).toUTCString()).isBefore(new Date(dateTimeObj?.startDtp).toUTCString())) {
                setStartDateError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                setEndDateError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const condominiumBoardElectionCreateAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionCreateAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let condominiumBoardRoleLodal = condominiumBoardElectionModelGet({});
            //#endregion variables

            //#region initialize
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data set
            response = await dataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion data set

            //#region formDataValidateAsync
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create condominium board election
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                condominiumBoardElection: condominiumBoardElection,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElections}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            condominiumBoardRoleLodal = response?.result || condominiumBoardRoleModelGet({});
            setCondominiumBoardElection(condominiumBoardRoleLodal);
            //#endregion create condominium board election

            //#region add record dt condominum board election
            const dtRows = [
                condominiumBoardRoleLodal?.startDate,
                condominiumBoardRoleLodal?.description,
                condominiumBoardRoleLodal?.status,
                dateTimeFormatGlobalSet({
                    date: condominiumBoardRoleLodal?.startDate,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    languageId: languageObj,
                    subMethod: currentMethod,
                })?.result,
                dateTimeFormatGlobalSet({
                    date: condominiumBoardRoleLodal?.endDate,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    languageId: languageObj,
                    subMethod: currentMethod,
                })?.result,
                buttonProcessGet({
                    id: condominiumBoardRoleLodal?.id,
                    description: condominiumBoardRoleLodal?.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ];

            $(`#${dtId}`)?.DataTable()?.row?.add(dtRows)?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#region add record dt condominum board election

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSet = ({ date = new Date(), startDate = '', endDate = '', subMethod = '', }) => {
        const currentMethod = 'dateInControlSet';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.start = '';
            //let dateTimeObj?.end = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                start: '',
                end: '',
                format: languageObj?.format?.date?.f1,
                //formatTwo: `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            if (!isUndNullEmp({ data: startDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.start = dateTimeFormatGlobalSet({
                    date: startDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.start = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (!isUndNullEmp({ data: endDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.end = dateTimeFormatGlobalSet({
                    date: endDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.end = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${startDateId}`)?.datetimepicker({
                date: moment(`${dateTimeObj?.start}`, dateTimeObj?.formatTwo),
                default: false,
                format: dateTimeObj?.formatTwo,
            });

            $(`#${endDateId}`)?.datetimepicker({
                //date: moment(`${localEndDate}`, localDateFormatTwo),
                date: moment(`${dateTimeObj?.end}`, dateTimeObj?.formatTwo).endOf('month'),
                default: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                start: $(`#${startDateId}`)?.datetimepicker('date')?._d,
                end: $(`#${endDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            //const dateTimeObj.start = $(`#${startDateId}`)?.datetimepicker('date')?._d;
            condominiumBoardElection.startDate = !isUndNullEmp({ data: dateTimeObj?.start, subMethod: currentMethod, })?.result ? dateTimeObj?.start : condominiumBoardElection?.startDate;

            //const dateTimeObj?.end = $(`#${endDateId}`)?.datetimepicker('date')?._d;
            condominiumBoardElection.endDate = !isUndNullEmp({ data: dateTimeObj?.end, subMethod: currentMethod, })?.result ? dateTimeObj?.end : condominiumBoardElection?.endDate;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const keyDownAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'keyDownAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.key, subMethod: currentMethod, })?.result && e?.key === 'Enter') {
                switch (e?.target?.id) {
                    case controls?.inputs?.startDate?.id:
                        condominiumBoardElectionCreateAsync({ e: e, subMethod: currentMethod, });
                        break;
                    case controls?.inputs?.endDate?.id:
                        condominiumBoardElectionCreateAsync({ e: e, subMethod: currentMethod, });
                        break;
                    default:
                        break;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.name?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.description?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.startDate?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.endDate?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps

    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.election?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.condominiumBoardElections}></img> - {processType === 0 ? labels?.add?.[languageObj?.id] : (processType === 1 ? labels?.edit?.[languageObj?.id] : labels?.detail?.[languageObj?.id])}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, })}>
                </button>
            </Modal.Header>
            {/* <form onSubmit={(e) => processType === 0 ? condominiumBoardElectionCreateAsync({e: e, subMethod: '', }) : (processType === 1 ? null : e.preventDefault())}> */}
            <form onSubmit={(e) => processType === 0 ? condominiumBoardElectionCreateAsync({ e: e, subMethod: 'form - onSubmit', }) : e?.preventDefault()}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? condominiumBoardElectionCreateAsync(e) : (processType === 1 ? localCondominiumBoardRoleEditPostAsync(e) : e.preventDefault())}> */}
                    {/* <form onSubmit={(e) => processType === 0 ? condominiumBoardElectionCreateAsync(e) : (processType === 1 ? null : e.preventDefault())}> */}
                    {/* <div className='card card-primary card-outline shadow-lg'> */}

                    {/*card header*/}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.election?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.condominiumBoardElections}></img> - {labels?.election?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/*card body*/}
                    {/* <div className='card-body '> */}
                    <div className='row '>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.name?.id}
                                        className={controls?.inputs?.name?.className}
                                        //className='form-control'
                                        //autoFocus
                                        onChange={(e) => setCondominiumBoardElection({ ...condominiumBoardElection, 'description': e?.target?.value, })}
                                        onFocus={() => setDescriptionError('')}
                                        placeholder={labels?.name?.[languageObj?.id]}
                                        tooltip='tooltip'
                                        title={labels?.name?.[languageObj?.id]}
                                        value={condominiumBoardElection?.description || ''} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                            </div>
                        </div>
                    </div>

                    <div className='row '>
                        <div className='col-md-12'>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <textarea id={controls?.inputs?.description?.id}
                                        className={controls?.inputs?.description?.className}
                                        //className='form-control'
                                        onChange={(e) => setCondominiumBoardElection({ ...condominiumBoardElection, 'remark': e?.target?.value, })}
                                        onFocus={() => setRemarkError('')}
                                        placeholder={labels?.description?.[languageObj?.id]}
                                        rows={3}
                                        tooltip='tooltip'
                                        title={labels?.description?.[languageObj?.id]}
                                        value={condominiumBoardElection?.remark || ''}>
                                    </textarea>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.edit} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                            </div>
                        </div>
                    </div>

                    <div className='row '>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                {/* <DatePicker /> */}
                                <div className='input-group mb-3'>
                                    <div id={startDateId} className='input-group date' data-target-input='nearest'>
                                        <input id={controls?.inputs?.startDate?.id}
                                            className='form-control text-black bg-transparent datetimepicker-input'
                                            data-target={`#${startDateId}`}
                                            data-toggle='datetimepicker'
                                            disabled={processType === 2}
                                            onFocus={() => {
                                                setEndDateError('');
                                                setStartDateError('');
                                            }}
                                            onKeyDown={(e) => keyDownAsync({ e: e, subMethod: startDateId })}
                                            placeholder={labels?.start?.[languageObj?.id]}
                                            tooltip='tooltip'
                                            title={labels?.start?.[languageObj?.id]}
                                            type='text' />
                                        <div className='input-group-append' data-target={`#${startDateId}`} data-toggle='datetimepicker'>
                                            <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(startDateError)}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className='form-group'>
                                {/* <DatePicker /> */}
                                <div className='input-group mb-3'>
                                    <div id={endDateId} className='input-group date' data-target-input='nearest'>
                                        <input id={controls?.inputs?.endDate?.id}
                                            className='form-control text-black bg-transparent datetimepicker-input'
                                            data-target={`#${endDateId}`}
                                            data-toggle='datetimepicker'
                                            disabled={processType === 2}
                                            onFocus={() => {
                                                setEndDateError('');
                                                setStartDateError('');
                                            }}
                                            onKeyDown={(e) => keyDownAsync({ e: e, subMethod: endDateId, })}
                                            placeholder={labels?.end?.[languageObj?.id]}
                                            tooltip='tooltip'
                                            title={labels?.end?.[languageObj?.id]}
                                            type='text' />
                                        <div className='input-group-append' data-target={`#${endDateId}`} data-toggle='datetimepicker'>
                                            <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(endDateError)}</div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/*card footer*/}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning'
                                    hidden={processType === 2}
                                    tooltip='tooltip'
                                    title={labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            //className='btn btn-outline-warning'
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}